import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'

import { AuthStore } from './auth.store'

/**
 * A route guard that prevents authenticated users from accessing certain routes.
 *
 * This guard checks if there is a currently authenticated user. If a user is authenticated,
 * it redirects them to the root route (`''`) and prevents access to the guarded route.
 * If no user is authenticated, it allows access to the route.
 *
 * @returns `true` if the user is not authenticated, allowing access to the route.
 *          `false` if the user is authenticated, redirecting them to the root route.
 */
export const redirectIfAuthGuard: CanActivateFn = () => {
  const authStore = inject(AuthStore)
  const router = inject(Router)

  const user = authStore.currentUser()

  if (user) {
    router.navigate([''])
    return false
  }

  return true
}
